import React from "react";

/**
 * Dropdown for choosing which module's dataset the query targets.
 * @param {object} props
 * @param {string} props.module the currently selected dataset key.
 * @param {Array<{key: string, label: string}>} props.datasets the registered datasets.
 * @param {(module: string) => void} props.onChange called with the new dataset key.
 * @returns {JSX.Element}
 */
export default function DatasetSelector({ module, datasets, onChange }) {
  return (
    <div className="qb-field">
      <label className="qb-label" htmlFor="qb-module">
        Dataset
      </label>
      <select
        id="qb-module"
        className="qb-select"
        value={module}
        onChange={(e) => onChange(e.target.value)}
      >
        <option value="">Select a dataset…</option>
        {datasets.map((d) => (
          <option key={d.key} value={d.key}>
            {d.label}
          </option>
        ))}
      </select>
    </div>
  );
}
